import { useMutation } from "react-query";
import { getCaptchaToken, useAxios } from "../hooks/useAxios";
import { ServerError } from "../data/shared";

export const useUpload = () => {
  var axios = useAxios();
  return useMutation<any, ServerError, FormData>(async (data: FormData) => {
    return axios.post(`/general/api/upload`, data, {
      headers: { "Content-Type": "multipart/form-data", Captcha: await getCaptchaToken() },
    });
  });
};
